import React, { Component } from "react";
import "./css-iptu-classes.css";
import Form, { SimpleItem, GroupItem, Label } from "devextreme-react/form";
import api from "../../../api-axios";
import ShowError from "../../../AppServices";
import { Button, LoadIndicator } from "devextreme-react";

let intervalId;

export default class AcompanharIptu extends Component {
  constructor() {
    super();

    this.state = {};

    this.onStartLooping = this.onStartLooping.bind(this);
    this.timer = this.timer.bind(this);
    this.renderProcessingStatus = this.renderProcessingStatus.bind(this);

    this.situacaoDs = [
      { id: 0, descricao: "PENDENTE" },
      { id: 1, descricao: "CANCELANDO" },
      { id: 2, descricao: "EXECUTANDO" },
      { id: 3, descricao: "FINALIZANDO" },
    ];

    this.tipoDs = [
      { id: 0, descricao: "INDEFINIDO" },
      { id: 1, descricao: "TODOS" },
      { id: 2, descricao: "POR INSCRIÇÃO" },
      { id: 3, descricao: "POR CARTOGRAFIA" },
      { id: 4, descricao: "POR DATA DE LANÇAMENTO" },
    ];
  }

  async componentDidMount() {
    if (this.props.match.params.id !== undefined) {
      api
        .get(`lancamentos/iptu/acompanhamento/${this.props.match.params.id}`)
        .then((response) => {
          if (response.data !== undefined) {
            this.setState({ ...response.data });
            this.onStartLooping(this.props.match.params.id);
          }
        })
        .catch((error) => {
          if (
            error.response &&
            error.response.data &&
            error.response.data.erros
          ) {
            ShowError(error.response.data.erros);
          } else {
            ShowError(error.message);
          }
        });
    }
  }

  onStartLooping(iptuId) {
    if (this.state.qtdePendente !== 0) {
      intervalId = setInterval(() => this.timer(iptuId), 5000);
    }
  }

  timer(iptuId) {
    api
      .get(`lancamentos/iptu/acompanhamento/${iptuId}`)
      .then((response) => {
        if (response.data !== undefined) {
          this.setState({ ...response.data });

          if (this.state.qtdePendente === 0) {
            clearInterval(intervalId);
          }
        }
      })
      .catch((error) => {
        if (
          error.response &&
          error.response.data &&
          error.response.data.erros
        ) {
          ShowError(error.response.data.erros);
        } else {
          ShowError(error.message);
        }
      });
  }

  renderProcessingStatus() {
    if (this.state.qtdePendente !== 0) {
      return (
        <div style={{ display: "flex", gap: "15px", alignItems: "center" }}>
          <p>IPTU EM PROCESSAMENTO</p>
          <LoadIndicator id="small-indicator" height={20} width={20} />
        </div>
      );
    }
  }

  renderStatusAmount({ editorOptions }, status = "", color="", fontWeight = "none") {
    const { value } = editorOptions;
    let quantity = 0;

    if (value && value.length > 0) {
      const statusItem = value.find((item) => {
        return item.status === status;
      });

      if (statusItem) {
        quantity = statusItem.qtde;
      }
    }

    return (
      <div className="iptu-card-render">
        <p style={{ color: color }}>{status}</p>
        <h2 style={{ color: color, fontWeight: fontWeight }}>{quantity}</h2>
      </div>
    );
  }

  render() {
    return (
      <React.Fragment>
        <div className={"content-block dx-card responsive-paddings"}>
          <form>
            <Form formData={this.state} colCount={2} labelLocation="top">
              <GroupItem caption="ACOMPANHAMENTO DE IPTU" colCount={3} colSpan={2}>
                <SimpleItem
                  dataField={"resumo"}
                  render={(e) => this.renderStatusAmount(e, "PENDENTE")}
                  editorOptions={{
                    readOnly: true,
                  }}
                >
                  <Label visible={false} />
                </SimpleItem>
                <SimpleItem
                  dataField={"resumo"}
                  render={(e) => this.renderStatusAmount(e, "SUCESSO", "green", "bold")}
                  colSpan={1}
                  editorOptions={{
                    readOnly: true,
                  }}
                >
                  <Label visible={false} />
                </SimpleItem>
                <SimpleItem
                  dataField={"resumo"}
                  colSpan={1}
                  render={(e) => this.renderStatusAmount(e, "FALHA", "red", "bold")}
                  editorOptions={{
                    readOnly: true,
                  }}
                >
                  <Label visible={false} />
                </SimpleItem>

              </GroupItem>
            </Form>
          </form>
          <br />
          <br />
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              flexDirection: "column"
            }}
          >
            {this.renderProcessingStatus()}
            <Button
              text="Fechar"
              onClick={() => this.props.history.push("/lancamentoiptu")}
              width={120}
            />
          </div>
        </div>
      </React.Fragment>
    );
  }
}
